import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href?: string;
  children: React.ReactNode;
  className?: string;
}
export const Button = ({
  href,
  children,
  className = '',
  ...props
}: ButtonProps) => {
  const baseStyle = 'block w-full text-center bg-orange-600 hover:bg-orange-500 text-white font-extrabold py-5 px-6 rounded-xl text-xl md:text-2xl shadow-[0_0_25px_rgba(249,115,22,0.5)] transition-all uppercase tracking-wide border-b-4 border-orange-800 active:border-b-0 active:translate-y-1';
  if (href) {
    return <motion.a whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} href={href} className={`${baseStyle} ${className}`} data-id="element-285">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyle} ${className}`} {...props} data-id="element-286">
      {children}
    </motion.button>;
};